<!-- Modal 1: "Verify Your Email" - Before Send Code -->
<div *ngIf="loggedIn && isOnetimeVerificationCodeExpired && !codeResentAfterExpiry" class="email-verify-modal">
  <p>To protect your account, we need to verify your email address.</p>

  <p>Enter the code sent to {{ registeredEmail }}, or select <strong>Send Code</strong> to receive one.</p>

  <!-- Error/Success Messages -->
  <ui-alert *ngIf="alertText" [alertText]="alertText" [alertStatus]="alertStatus" [fullWidth]="false" class="mb-3"> </ui-alert>

  <!-- Verification Form or Loading Spinner -->
  <div *ngIf="isResendingCode || (proccessing$ | async)" class="loading-container text-center">
    <div class="spinner-border text-gray" role="status"></div>
    <p class="small text-gray">Loading...</p>
  </div>

  <form *ngIf="!isResendingCode && (proccessing$ | async) === false" [formGroup]="verifyCodeForm" (ngSubmit)="onSubmit()">
    <label for="verificationCode" class="form-label">Verification Code</label>
    <div class="input-verify-container d-flex flex-column flex-sm-row flex-wrap mb-2">
      <input
        id="verificationCode"
        type="text"
        formControlName="verificationCode"
        class="form-control verification-input flex-sm-grow-1 mb-0"
        [disabled]="proccessing$ | async"
        maxlength="4"
        oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"
      />
      <ui-form-field-msg
        id="verificationCodesError"
        [validationMessages]="validationMessages.pin"
        controlName="verificationCode"
        class="w-100 order-sm-3 mb-3 mb-sm-0"
      ></ui-form-field-msg>
      <ui-button
        type="submit"
        [buttonText]="'Verify'"
        [disabled]="!verifyCodeForm.valid || (proccessing$ | async)"
        [minWidth]="0"
        [addClass]="'w-100 w-sm-auto'"
        (handleClick)="onSubmit()"
      ></ui-button>
    </div>
  </form>

  <p class="info-text">Verification codes are valid for 20 minutes.</p>

  <!-- Bottom Buttons -->
  <div class="d-flex flex-column-reverse flex-sm-row justify-content-sm-end gap-3 mt-4">
    <ui-button
      [rank]="'secondary'"
      [buttonText]="'Sign Out'"
      [minWidth]="140"
      [addClass]="'w-100 w-sm-auto'"
      (handleClick)="signOut()"
    ></ui-button>
    <ui-button [buttonText]="'Send Code'" [minWidth]="140" [addClass]="'w-100 w-sm-auto'" (handleClick)="resendCode()"></ui-button>
  </div>
</div>

<!-- Modal 2: "Enter Verification Code" - After Send Code -->
<div *ngIf="loggedIn && !isOnetimeVerificationCodeExpired && codeResentAfterExpiry" class="email-verify-modal">
  <p>Enter the code we sent to {{ registeredEmail }}.</p>

  <!-- Error/Success Messages -->
  <ui-alert *ngIf="alertText" [alertText]="alertText" [alertStatus]="alertStatus" [fullWidth]="false" class="mb-3"> </ui-alert>

  <!-- Verification Form or Loading Spinner -->
  <div *ngIf="isResendingCode || (proccessing$ | async)" class="loading-container text-center">
    <div class="spinner-border text-gray" role="status"></div>
    <p class="small text-gray">Loading...</p>
  </div>

  <form *ngIf="!isResendingCode && (proccessing$ | async) === false" [formGroup]="verifyCodeForm" (ngSubmit)="onSubmit()">
    <label for="verificationCode" class="form-label">Verification Code</label>
    <input
      id="verificationCode"
      type="text"
      formControlName="verificationCode"
      class="form-control verification-input"
      [disabled]="proccessing$ | async"
      maxlength="4"
      oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"
    />
    <ui-form-field-msg
      id="verificationCodesError"
      [validationMessages]="validationMessages.pin"
      controlName="verificationCode"
    ></ui-form-field-msg>
  </form>

  <p class="info-text">Verification codes are valid for 20 minutes.</p>

  <p class="helper-text">If you didn't receive a code, check your spam folder or select <strong>Resend Code</strong>.</p>

  <!-- Bottom Buttons -->
  <div class="d-flex flex-column-reverse flex-sm-row justify-content-sm-end gap-3 mt-4">
    <ui-button
      [rank]="'link'"
      [buttonText]="'Sign Out'"
      [minWidth]="120"
      [addClass]="'w-100 w-sm-auto'"
      (handleClick)="signOut()"
    ></ui-button>
    <ui-button
      [rank]="'secondary'"
      [buttonText]="'Resend Code'"
      [minWidth]="120"
      [addClass]="'w-100 w-sm-auto'"
      (handleClick)="resendCode()"
    ></ui-button>
    <ui-button
      type="submit"
      [buttonText]="'Verify'"
      [disabled]="!verifyCodeForm.valid || (proccessing$ | async)"
      [minWidth]="120"
      [addClass]="'w-100 w-sm-auto'"
      (handleClick)="onSubmit()"
    ></ui-button>
  </div>
</div>

<!-- Non-logged-in user flows (token and acttoken) - UNCHANGED -->
<div *ngIf="!loggedIn" class="container-xl">
  <header>
    <div class="row">
      <div class="col">
        <h2 class="mt-6 mt-sm-1">Email Verification</h2>
      </div>
    </div>
  </header>

  <div class="row ms-0">
    <h5 class="mb-5 mb-sm-2 ps-0">
      We've sent a one-time verification code to <strong>{{ registeredEmail }}</strong
      >.
    </h5>
  </div>

  <div class="row ms-0 me-0">
    <div class="ps-0 col-12">
      <div class="info-box" [innerHTML]="showErrorAlert ? infoText : alertText"></div>
    </div>

    <ui-alert *ngIf="showErrorAlert" [alertTextTemplate]="errorAlertTemplate" [alertStatus]="'danger'" [fullWidth]="false" class="ps-0">
    </ui-alert>
    <ng-template #errorAlertTemplate>
      <div class="text" [innerHTML]="errorAlertText"></div>
    </ng-template>

    <ui-alert *ngIf="codeResent" [alertTextTemplate]="codeResentTemplate" [alertStatus]="'success'" [fullWidth]="false" class="ps-0">
    </ui-alert>
    <ng-template #codeResentTemplate>
      <div class="text" [innerHTML]="'A new verification code was sent to your email.'"></div>
    </ng-template>
  </div>

  <form [formGroup]="verifyCodeForm">
    <div class="row form-group ps-0">
      <div *ngIf="proccessing$ | async; else codeFormTemplate" class="text-center">
        <div class="spinner-border text-gray" role="status"></div>
        <p class="small text-gray">Loading...</p>
      </div>
      <ng-template #codeFormTemplate>
        <div class="row w-100 mt-5 mt-sm-1">
          <div class="col-12 col-md-4 col-lg-3">
            <label for="verificationCode" class="verification-label">Verification Code</label>
            <input
              name="pin"
              type="text"
              maxlength="4"
              class="form-control"
              formControlName="verificationCode"
              id="verificationCode"
              oninput="pin.value = pin.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"
              [class.is-invalid]="verifyCodeForm.controls.verificationCode.invalid && verifyCodeForm.controls.verificationCode.dirty"
            />
            <ui-form-field-msg
              id="verificationCodesError"
              [validationMessages]="validationMessages.pin"
              controlName="verificationCode"
            ></ui-form-field-msg>
          </div>
        </div>
      </ng-template>
    </div>

    <div class="row ps-0">
      <div class="form-group d-flex flex-column-reverse flex-md-row gap-md-6 col-12">
        <ui-button
          id="btnVerify"
          [fullWidth]="true"
          [addClass]="'mt-1 mt-md-0'"
          [buttonText]="'Verify'"
          (handleClick)="onSubmit()"
        ></ui-button>

        <button id="btnResendCode" type="button" class="btn mt-6 mt-md-0 btn-outline-primary" (click)="resendCode()">Resend Code</button>
      </div>
    </div>
  </form>
</div>
